'use strict';

import footerTemplate from './footer.html';

var footerController = function() {

    var vm = this;
    vm.year = null;

    vm.$onInit = function() {
        vm.year = new Date().getFullYear();
    }
};

footerController.$inject = [ ];

export var footerComponent = {
    name: 'footer',
    template: footerTemplate,
    controller: footerController,
    controllerAs: 'vm'
};